namespace Areas.Account.StatusReport {
    "use strict";

    let accountStatusReportId: number = 0;
    let accountId: number = 0;
    let projectCCNumber: string;
    let projectCCNumberName: string;
    let accountName: string;
    const baseUrl = "/Account/AccountStatusReport";


    export function insertRecord() {
        const form = $("#StatusReportForm").dxForm("instance");

        accountId = form.option("AccountId") as number;

        $.get(`${baseUrl}/AddAccountStatusReport/${accountId}`,
            (data) => {
                form.option("formData", data);
            });

    }

    export function updateRecord() {
        const form = $("#StatusReportForm").dxForm("instance");
        const newData: any = form.option("formData");

        if (newData.accountStatusReportId == 0) {
            saveRecord(newData);
        } else {
            updateReportRecord(newData)
        }
    }

    function saveRecord(newData: any) {

        const url = `${baseUrl}/Post`;
        const method = "POST";

        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    function updateReportRecord(newData: any) {
        const url = `${baseUrl}/Put/${newData.accountStatusReportId}`;
        const method = "PUT";
        
        sendRequest(url,
            JSON.stringify(newData),
            method,
            (data) => {
                Areas.reloadPage();
            });
    }

    export function deleteRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to Delete this record?");

        if (verifyVoid) {
            const form = $("#StatusReportForm").dxForm("instance");
            const keyId: any = form.option("KeyId");

            if (keyId != null) {
                sendRequest(`/StatusReport/Edit/Delete/${keyId}/`, "", "DELETE");
            }
        }
    }

    //
    export function onGridSelectionChanged(e: any) {
        let rowData: any = e.selectedRowsData[0];
        let rowForm: any = $("#StatusReportForm").dxForm("instance");
        rowForm.option("formData", rowData);                                                                             
    }



    //goto functions
    export function goBack() {
        window.history.back();
    }



    export function gotoCreate(e) {
        var linkInfo = "/StatusReport/Create/Index/";
        location.href = linkInfo;
    }



    export function gotoEdit() {
        var dataGrid = $('#StatusReportGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Account/StatusReport/Edit/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoView() {
        var dataGrid = $('#StatusReportGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Account/StatusReport/View/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }


}

